export default __webpack_public_path__ + "static/media/Group9207.14780ddf.svg";